import { QrCode, Search } from 'lucide-react';

interface QrCodeSearchStackProps {
  size?: number;
  className?: string;
}

const QrCodeSearchStack = ({ size = 32, className = '' }: QrCodeSearchStackProps) => (
  <span className={`relative inline-block ${className}`} style={{ width: size, height: size }}>
    <QrCode size={size} className="text-inherit" />
    <span
      className="absolute flex items-center justify-center"
      style={{
        top: size * 0.01,
        right: size * 0.01,
        width: size * 0.58,
        height: size * 0.58,
      }}
    >
      <span
        className="bg-gradient-to-br from-white to-blue-50 rounded-full shadow-[0_2px_8px_rgba(37,99,235,0.3)] flex items-center justify-center border border-blue-100 hover:scale-110 transition-transform duration-300"
        style={{
          width: size * 0.70,
          height: size * 0.70,
          boxShadow: `0 ${size * 0.03}px ${size * 0.08}px rgba(37, 99, 235, 0.3)`,
        }}
      >
        <Search
          size={size * 1.5}
          strokeWidth={3}
          className="text-blue-600 drop-shadow-sm translate-x-[2%] translate-y-[2%]"
        />
      </span>
    </span>
  </span>
);

export default QrCodeSearchStack;
